var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('b-img',{staticStyle:{"margin-top":"20"},attrs:{"center":"","src":"corporacion.svg","width":"160"}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }